import { isNone, isEmpty } from '@ember/utils';
import EmptyTemplate from 'cio/data/bee/empty-template';

const EmptyTemplateJson = JSON.stringify(EmptyTemplate);

export type MergeTag = { name: string; value: string };

export const EDITORS = {
  bee: {
    name: 'bee',
    label: 'drag-and-drop',
    iconType: 'editor-drag-and-drop',
    description: 'A block builder for responsive emails -- no coding required!',
  },
  wysiwyg: {
    name: 'wysiwyg',
    label: 'rich text',
    iconType: 'editor-rich-text',
    description: 'Create basic text emails and make changes to the code if needed.',
  },
  html: {
    name: 'html',
    label: 'code',
    iconType: 'editor-code',
    description: 'Raw HTML code for more control, with rich text options.',
  },
  visual: {
    name: 'visual',
    label: 'New editor',
    iconType: 'a-b-test',
    description: 'Create emails with draggable blocks and code side-by-side.',
  },
  in_app_classic: {
    name: 'json',
    label: 'Standard',
    iconType: 'in-app',
    description: 'Choose one of your existing in-app messages.',
  },
  in_app_visual: {
    name: 'visual',
    label: 'Code',
    iconType: 'editor-code',
    description: 'Take complete control by using HTML.',
  },
};

export enum InAppEditorName {
  VISUAL = 'in_app_visual',
  CLASSIC = 'in_app_classic',
}

export const isEmptyTemplate = (json: string) => {
  return isNone(json) || isEmpty(json) || json === EmptyTemplateJson;
};
